<template>
    <ol
        role="list"
        class="space-y-4 md:flex md:space-y-0 md:space-x-8"
    >
        <slot />
    </ol>
</template>
